export default function CheckmarkIcon() {
   return (
      <>
         <svg
            className="checkmark"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M16.2639 2.62109C19.9332 2.6874 23.4297 4.19154 26.0011 6.80984C28.5725 9.42813 30.0132 12.9513 30.0132 16.6211C30.0132 20.2909 28.5725 23.8141 26.0011 26.4324C23.4297 29.0506 19.9332 30.5548 16.2639 30.6211C12.5947 30.5548 9.09818 29.0506 6.52678 26.4324C3.95537 23.8141 2.51465 20.2909 2.51465 16.6211C2.51465 12.9513 3.95537 9.42813 6.52678 6.80984C9.09818 4.19154 12.5947 2.6874 16.2639 2.62109ZM13.3565 21.1689L9.92794 17.7373C9.6473 17.4557 9.48971 17.0743 9.48971 16.6767C9.48971 16.2791 9.6473 15.8978 9.92794 15.6161C10.2104 15.3365 10.5918 15.1797 10.9893 15.1797C11.3867 15.1797 11.7681 15.3365 12.0506 15.6161L14.4658 18.0344L20.4773 12.023C20.7589 11.7424 21.1403 11.5848 21.5378 11.5848C21.9354 11.5848 22.3168 11.7424 22.5984 12.023C22.8787 12.3048 23.036 12.6861 23.036 13.0836C23.036 13.481 22.8787 13.8623 22.5984 14.1441L15.5249 21.2177C15.3813 21.3605 15.2103 21.4729 15.0222 21.5481C14.8342 21.6232 14.6328 21.6596 14.4303 21.6551C14.2278 21.6505 14.0283 21.6051 13.8438 21.5216C13.6593 21.438 13.4935 21.3181 13.3565 21.1689Z"
               fill="#1F473E"
            />
         </svg>
      </>
   )
}
